import { useEffect, useRef, useState } from "react";
import { ImageType } from "../../interfaces/intakes.reports"
import { AiOutlineRotateLeft, AiOutlineRotateRight } from "react-icons/ai";

interface Props {
    image: ImageType
    onRotateEnd: (file: File) => void

}
export const RotateImage = ({ image, onRotateEnd }: Props) => {

   const canvasRef = useRef<HTMLCanvasElement | null>(null);
  const imgRef = useRef<HTMLImageElement | null>(null);

  const [rotation, setRotation] = useState(0);

  // 🖼️ Cargar imagen
  useEffect(() => {
    const img = new Image();
    img.crossOrigin = "anonymous"; // IMPORTANTE para canvas + URLs
    img.src = image.imgURL || image.imgURL_low || "";

    img.onload = () => {
      imgRef.current = img;
      drawImage(rotation);
    };
  }, [image]);

  // 🔄 Redibujar al rotar
  useEffect(() => {
    drawImage(rotation);
  }, [rotation]);

  const drawImage = (angle: number) => {
    const canvas = canvasRef.current;
    const img = imgRef.current;
    if (!canvas || !img) return;

    const ctx = canvas.getContext("2d");
    if (!ctx) return;

    const radians = (angle * Math.PI) / 180;

    const width = img.width;
    const height = img.height;

    // Ajustar canvas según rotación
    const isRotated = Math.abs(angle) % 180 !== 0;
    canvas.width = isRotated ? height : width;
    canvas.height = isRotated ? width : height;

    ctx.clearRect(0, 0, canvas.width, canvas.height);

    ctx.save();
    ctx.translate(canvas.width / 2, canvas.height / 2);
    ctx.rotate(radians);
    ctx.drawImage(img, -width / 2, -height / 2);
    ctx.restore();

    canvas.toBlob((blob) => {
      if (!blob) return;

      const file = new File([blob], image.key || "rotated-image.jpg", {
        type: blob.type,
        lastModified: Date.now(),
      });

      onRotateEnd(file);
    }, "image/jpeg", 0.95);
  };

  return (
    <div className="tw-flex tw-flex-col tw-gap-4 tw-h-full tw-w-full tw-py-4">
      {/* Botones */}
      <div className="tw-flex tw-justify-center tw-gap-6">
        <button
          onClick={() => setRotation((r) => r - 90)}
          className="tw-bg-gray-800 tw-rounded-full tw-p-2"
        >
          <AiOutlineRotateLeft size={20} color="white" />
        </button>

        <button
          onClick={() => setRotation((r) => r + 90)}
          className="tw-bg-gray-800 tw-rounded-full tw-p-2"
        >
          <AiOutlineRotateRight size={20} color="white" />
        </button>
      </div>

      {/* Preview */}
      <div className="tw-flex tw-justify-center tw-items-center tw-w-full tw-h-full">
        <canvas
          ref={canvasRef}
          className="tw-max-w-full tw-max-h-full tw-object-contain"
        />
      </div>
    </div>
  );
}

// <div className="tw-space-y-4 tw-h-full tw-w-full tw-py-4">
//     <div className="tw-flex tw-justify-center tw-w-full tw-gap-6 tw-pt-2">
//         <button><AiOutlineRotateLeft size={20} color="white" /></button>
//         <button><AiOutlineRotateRight size={20} color="white" /></button>
//     </div>
//     <div className="tw-flex tw-justify-center tw-align-center tw-aspect-square tw-h-full tw-w-full">
//         <img key={image.key} src={image.imgURL || image.imgURL_low} alt="stageImg" className="tw-h-full tw-w-full tw-object-contain"/>
//     </div>
// </div>
